import { render } from "./performance-indicator.vue?vue&type=template&id=61d37b7b"
import script from "./performance-indicator.vue?vue&type=script&lang=js"
export * from "./performance-indicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__